<template>
  <div class="tian-deail" :class="{
    'sold-out': item.isFull
  }" @click.stop.prevent="onToDetail(item)">
    <div class="right-bg">
      <div class="product-information">
        <div class="title">
          <span>{{ item.name }}</span>
          <img v-if="
            item.productLevel == 4 &&
            item.serverTime <= item.endTime
          " class="hot-tag" src="../assets/img/kaimenhong.png" alt />
        </div>
        <div class="tag-bg">
          <van-tag v-if="item.label1" plain color="#ff9900">{{
            item.label1
          }}</van-tag>
          <van-tag v-if="item.label2" plain color="#ff9900">{{
            item.label2
          }}</van-tag>
          <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
            item.attachLabel
          }}</van-tag>
        </div>
        <div class="bottom-bg">
          <div class="left">
            <div class="title2" v-if="item.ifStair">
              {{ rateInterval(item).minRate }}<span>% ~ </span>{{ rateInterval(item).maxRate }}<span>%</span>
            </div>
            <div class="title2" v-else>
              {{ expectedRate(item) }}<span>%</span>
              <template v-if="item.greenhandRate && item.greenhandRate > 0">
                <span>+</span>{{ item.greenhandRate }}<span>%</span>
              </template>
            </div>
            <div class="title1">对应年化收益率</div>
          </div>
          <div class="right">
            <div class="day">
              <span class="s1">{{ item.investDuration }}</span>
              <span class="s2">天</span>
            </div>
            <div class="title1">期限</div>
          </div>
        </div>
        <div class="progress-bg">
          <van-progress :percentage="isSoldOut(item) ? 100 : item.sold" stroke-width="7" :show-pivot="false"
            color="#fc6524" />
          <div class="result">{{ progressText(item) }}</div>
        </div>
        <div class="signet-sold-out" v-if="item.isFull">已结束</div>
        <div class="aside" v-else-if="item.saleLabel">{{ saleLabelName(item.saleLabel) }}</div>
        <div v-else class="aside">新品</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Progress, Tag } from "vant"
export default {
  name: "AuctionItem",
  components: {
    [Tag.name]: Tag,
    [Progress.name]: Progress
  },
  props: {
    item: {
      required: true
    }
  },
  methods: {
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    saleLabelName(saleLabel) {
      switch (saleLabel) {
        case '1':
          return "新手";
          break;
        case '2':
          return "热销";
          break;
        case '3':
          return "普通";
          break;
        case '4':
          return "秒杀";
          break;
        case '5':
          return "限时限量";
          break;
        case '6':
          return "体验款";
          break;
        default:
          return "新品";
          break;
      }
    },
    // 利率
    rateInterval: function (n) {
      if (n.ifStair) {
        let stairRate = n.productType == 5 ? n.pydStairRate : n.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (n.productType == 5) {
              if (minRate > n.pydStairRate["rate" + k]) {
                minRate = n.pydStairRate["rate" + k]
              }
              if (maxRate < n.pydStairRate["rate" + k]) {
                maxRate = n.pydStairRate["rate" + k]
              }
            } else {
              if (minRate > n.stairRate["rate" + k]) {
                minRate = n.stairRate["rate" + k]
              }
              if (maxRate < n.stairRate["rate" + k]) {
                maxRate = n.stairRate["rate" + k]
              }
            }
          }
        })
        if (n.hasNewYearActivity && n.activityDiscount) {
          //有新年红包活动
          return {
            minRate: parseFloat(minRate + n.activityDiscount.rate).toFixed(2),
            maxRate: parseFloat(maxRate + n.activityDiscount.rate).toFixed(2)
          }
        } else {
          return { minRate: minRate, maxRate: maxRate }
        }
      }
    },
    expectedRate: function (n) {
      if (n.productType == 5) {
        if (n.hasNewYearActivity && n.activityDiscount) {
          return parseFloat(n.pydExpectedRate + n.activityDiscount.rate).toFixed(2)
        } else {
          return n.pydExpectedRate
        }
      } else {
        if (n.hasNewYearActivity && n.activityDiscount) {
          return parseFloat(n.expectedRate + n.activityDiscount.rate).toFixed(2)
        } else {
          return n.expectedRate
        }
      }
    },
    onToDetail(product) {
      this.$router.push({
        // path: "/claimDetail",
        path: "/detail",
        query: { productId: product.id }
      })
    },
    progressText: function (item) {
      if (this.isSoldOut(item)) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .van-tag--large {
  font-size: 12px;
  padding-left: 25px;
}

.tian-deail {
  display: flex;
  background-color: white;
  align-items: center;
  margin: 10px 13px;
  border-radius: 8px;

  &.sold-out {
    filter: grayscale(0%) opacity(0.6);
  }

  .right-bg {
    width: 100%;
    margin: 10px 0 10px 0;

    .product-information {
      position: relative;
      padding: 5px 12px;
      border-radius: 5px;

      // title
      .title {
        margin-right: 70px;
        font-size: 16px;
        overflow: hidden;
        color: #333333;
        word-break: break-all; //等宽显示再换行

        .hot-tag {
          width: 35px;
          margin-left: 5px;
        }
      }

      .tag-bg .van-tag {
        font-size: 12px;
        margin-right: 3px;
      }

      .bottom-bg {
        display: flex;
        // justify-content: space-between;
        align-items: flex-end;
        margin-top: 0px;
        margin-right: 0px;

        .title1 {
          font-size: 14px;
          color: rgb(150, 150, 150);
        }

        .left {
          width: 63%;

          .title2 {
            font-size: 36px;
            color: #fc6524;

            span {
              font-size: 15px;
              margin-left: 1px;
            }
          }
        }

        .right {
          .day {
            line-height: 53px;
            font-size: 22px;
            color: #666;

            .s2 {
              font-size: 18px;
            }
          }
        }
      }

      .progress-bg {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .van-progress {
          width: 250px;
        }

        .result {
          font-size: 14px;
          margin-left: 10px;
          color: #666;
        }
      }

      .aside,
      .signet-sold-out {
        position: absolute;
        top: 5px;
        right: 0px;
        padding: 0 12px;
        line-height: 24px;
        text-align: center;
        font-size: 13px;
        box-sizing: border-box;
        border-radius: 25px 0 0 25px;
        color: #fff;
      }

      .aside {
        background-color: #fc6524;
      }

      .signet-sold-out {
        background-color: #d6d6d7;
      }
    }
  }
}
</style>